import React, { FC, MouseEvent, useCallback } from 'react'

import { Colors } from 'common-constants/colors'
import { Wrapper } from 'components/page/PhotoViewer/PhotoViewerCloseButton/PhotoViewerCloseButton.styled'
import { CloseSvg } from 'components/presentational/svg/CloseSvg'
import { useLayoutContext } from 'hooks/useLayoutContext'

export const PhotoViewerCloseButton: FC<{
  onClosePhotoViewer: () => void
}> = ({ onClosePhotoViewer }) => {
  const { baseUrl } = useLayoutContext()
  const handle = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      onClosePhotoViewer()
    },
    [onClosePhotoViewer]
  )

  return (
    <Wrapper
      $dark={false}
      href={baseUrl}
      onClick={handle}
      data-name="modal-photoviewer-close-button"
    >
      <CloseSvg stroke={Colors.white} />
    </Wrapper>
  )
}
